import React from 'react';
import styled from 'styled-components';
import { IconChevronRight, Type } from '@spotify-internal/encore-web';
import { Supertext, Link } from '../../../ui';
import { SearchHit } from '../../../Search';
import { hexToRgba } from '@mrkt/features/color-conversion';
import {
  screenMdMax,
  screenXsMax,
  spacer8,
  spacer16,
  spacer24,
  heading4FontWeight,
} from '@spotify-internal/encore-foundation';
import { hidden } from '../../util';

const ItemWrapper = styled(Link)`
  background: ${({ theme }) => theme.box.background};
  color: ${({ theme }) => theme.link.color};
  width: calc(25% - ${spacer16});

  &:hover:not(:focus):not(:disabled) {
    color: ${({ theme }) => hexToRgba(theme.link.color, 0.75)};
  }

  @media (max-width: ${screenMdMax}) {
    margin: 0 ${spacer16} ${spacer16} 0;
    width: calc(50% - ${spacer24});
  }

  @media (max-width: ${screenXsMax}) {
    width: calc(100% - ${spacer16});
    margin: 0 0 ${spacer16} 0;
  }
`;

const TextWrapper = styled.div`
  width: calc(100% - ${spacer16});

  @media (max-width: ${screenMdMax}) {
    width: 100%;
  }

  @media (max-width: ${screenXsMax}) {
    width: 100%;
  }
`;

const Title = styled(Type.h1).attrs({
  variant: Type.heading4,
  weight: Type.bold,
})`
  @media (max-width: ${screenXsMax}) {
    width: 90%;
    font-weight: ${heading4FontWeight};
    padding: ${spacer8} 0px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: ${screenXsMax}) {
    align-items: center;
    justify-content: space-between;
  }
`;

const StyledSupertext = styled(Supertext)`
  @media (max-width: ${screenXsMax}) {
    ${hidden}
  }
`;

const StyledChevronRightIcon = styled(IconChevronRight)`
  display: none;

  @media (max-width: ${screenXsMax}) {
    display: flex;
    align-self: center;
  }
`;

const TRACK_CAT = 'helpFAQ';

export const FAQItem: React.FC<SearchHit> = hit => {
  return (
    <ItemWrapper
      data-testid="faq-item"
      href={hit.url}
      track={[TRACK_CAT, 'FAQ Link']}
    >
      {hit.label && hit.title && (
        <TextWrapper>
          <StyledSupertext>{hit.label}</StyledSupertext>
          <TitleContainer>
            <Title>{hit.title}</Title>
            <StyledChevronRightIcon iconSize={16} />
          </TitleContainer>
        </TextWrapper>
      )}
    </ItemWrapper>
  );
};
